import { render, staticRenderFns } from "./NewRealEstateComparison.vue?vue&type=template&id=429fb3f0&scoped=true&"
import script from "./NewRealEstateComparison.vue?vue&type=script&lang=js&"
export * from "./NewRealEstateComparison.vue?vue&type=script&lang=js&"
import style0 from "./NewRealEstateComparison.vue?vue&type=style&index=0&id=429fb3f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429fb3f0",
  null
  
)

export default component.exports